import { useFormContext } from "react-hook-form";
import { Trash2, ArrowDown, ArrowUp, Network } from "lucide-react";

export type QuestionActionsProps = {
	questionIndex: number;
	questions: AdminObservationQuestion[];
	moveQuestionUp: (
		index: number,
		answerOne: number | null,
		answerTwo: number | null
	) => void;
	moveQuestionDown: (
		index: number,
		answerOne: number | null,
		answerTwo: number | null
	) => void;
	removeQuestion: () => void;
	isBranchButtonVisible?: boolean;
	onBranchedQuestionsPreviewOpen?: () => void;
};
const QuestionActions = ({
	questionIndex,
	questions,
	moveQuestionUp,
	moveQuestionDown,
	removeQuestion,
	isBranchButtonVisible = true,
	onBranchedQuestionsPreviewOpen
}: QuestionActionsProps) => {
	const { setValue } = useFormContext<AdminObservationForm>();

	const handleBranchedQuestionsPreviewOpen = () => {
		onBranchedQuestionsPreviewOpen?.();
	};

	return (
		<>
			<div className="absolute top-2 right-2 flex flex-row gap-1 py-1 px-1.5 rounded-lg border border-border bg-white shadow-sm z-10">
				<div className="flex flex-row gap-0.5">
					<button
						type="button"
						className="inline-flex items-center justify-center rounded p-1 hover:bg-foreground hover:text-white disabled:bg-white disabled:text-muted-foreground disabled:opacity-100 disabled:pointer-events-auto disabled:cursor-not-allowed transition-colors"
						onClick={(e) => {
							e.stopPropagation();
							const answerOneId = questions[questionIndex].id;
							const answerTwoId = questions[questionIndex - 1].id;
							moveQuestionUp(questionIndex, answerOneId, answerTwoId);

							if (!answerOneId || !answerTwoId) return;
							setValue("selectedQuestionIndex", questionIndex - 1);
						}}
						disabled={questionIndex === 0}
						aria-label="Move Question Up"
						title="Move Question Up"
					>
						<ArrowUp size={16} />
					</button>

					<button
						type="button"
						className="inline-flex items-center justify-center rounded p-1 hover:bg-foreground hover:text-white disabled:bg-white disabled:text-muted-foreground disabled:opacity-100 disabled:pointer-events-auto disabled:cursor-not-allowed transition-colors"
						onClick={(e) => {
							e.stopPropagation();
							const answerOneId = questions[questionIndex].id;
							const answerTwoId = questions[questionIndex + 1].id;
							moveQuestionDown(questionIndex, answerOneId, answerTwoId);

							if (!answerOneId || !answerTwoId) return;
							setValue("selectedQuestionIndex", questionIndex + 1);
						}}
						disabled={questionIndex === questions.length - 1}
						aria-label="Move Question Down"
						title="Move Question Down"
					>
						<ArrowDown size={16} />
					</button>

					<button
						type="button"
						className="inline-flex items-center justify-center rounded p-1 text-destructive hover:bg-foreground hover:text-white transition-colors"
						onClick={(e) => {
							e.stopPropagation();
							removeQuestion();
						}}
						aria-label="Delete Question"
						title="Delete Question"
					>
						<Trash2 size={16} />
					</button>
				</div>

				{isBranchButtonVisible && (
					<>
						<div className="w-px bg-border self-stretch" />

						<button
							type="button"
							className="inline-flex items-center justify-center rounded p-1 hover:bg-foreground hover:text-white transition-colors"
							aria-label="Branch Question"
							title="Branch Question"
							onClick={handleBranchedQuestionsPreviewOpen}
						>
							<Network size={16} />
						</button>
					</>
				)}
			</div>
		</>
	);
};

export default QuestionActions;
